import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { venomHistory } from 'client/utils/history/venom-history';
import { isPageChanged } from 'client/utils/location';
import { makeRouteParams } from './routes';

function renderSwitchRoutes(routes, redirects) {
  return (
    <Switch>
      {redirects && redirects.map(({ from, to }) => <Redirect key={from} exact from={from} to={to} />)}
      {routes.map(route => (
        <Route key={route.path} {...makeRouteParams(route)} />
      ))}
    </Switch>
  );
}

function renderInitialRoute(routeProps) {
  return <Route {...routeProps} />;
}

function ifRouteChanged(currentLocation, newLocation) {
  if (isPageChanged(currentLocation, newLocation)) {
    return true;
  }
  return false;
}

/**
 * App component
 */
export const App = ({ store, routeProps, routes, currentRoute, location, redirects = null } = {}) => {
  return (
    <Provider store={store}>
      <Router history={venomHistory}>
        <Route
          render={({ location: routerLocation }) =>
            ifRouteChanged(location, routerLocation, currentRoute)
              ? renderSwitchRoutes(routes, redirects)
              : renderInitialRoute(routeProps)
          }
        />
      </Router>
    </Provider>
  );
};

/**
 * App component prop types definition
 */
App.propTypes = {
  store: PropTypes.object.isRequired,
  routeProps: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  currentRoute: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  redirects: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    })
  ),
};
